// // import React from "react";

// // import "./Blog.css";
// // import BLogImg from "../../assets/Images/Blog_hero.png";
// // import BlogCard from "./BlogCard";
// // import Blog1 from "../../assets/Images/Blog1.png";
// // import Footer from "../../components/Footer/index.js";
// // import { useNavigate } from "react-router-dom";
// // const Blog = ({
// //   title = "ISO Knowledge Hub",
// //   description = "Expert insights, best practices, and latest updates on ISO certification and quality management",
// // }) => {
// //   const navigate = useNavigate();



// //   return (


// //     <div>
// //       <section className="blog-featured">
// //         <div className="blog-image">
// //           <img src={BLogImg} alt="Blog cover" />
// //           <div className="overlay"></div>
// //         </div>
// //         <div className="blog-content">
// //           <h1 className="blog-title">{title}</h1>
// //           <p className="blog-description">{description}</p>
// //         </div>
// //       </section>
// //       <section className="featured-section">
// //         <div className="section-label-wrapper">
// //           <div className="section-label">
// //             <span className="dot"></span>
// //             <span className="label-text">Featured Article</span>
// //           </div>
// //         </div>
// //         <div className="featured-card">
// //           <div className="featured-image">
// //             <span className="badge">ISO</span>
// //             <img src={Blog1} alt="ISO Article" />
// //           </div>
// //           <div className="featured-content">
// //             <div className="card1">
// //               <div className="meta">
// //                 <div className="meta-item">
// //                   <svg width="20" height="20" viewBox="0 0 64 64" fill="none">
// //                     <rect
// //                       x="12"
// //                       y="18"
// //                       width="40"
// //                       height="34"
// //                       rx="6"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <line
// //                       x1="12"
// //                       y1="26"
// //                       x2="52"
// //                       y2="26"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <line
// //                       x1="22"
// //                       y1="12"
// //                       x2="22"
// //                       y2="22"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                     <line
// //                       x1="42"
// //                       y1="12"
// //                       x2="42"
// //                       y2="22"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                   </svg>
// //                   <span>January 25, 2026</span>
// //                 </div>
// //                 <div className="meta-item">
// //                   <svg width="20" height="20" viewBox="0 0 64 64" fill="none">
// //                     <circle
// //                       cx="32"
// //                       cy="22"
// //                       r="8"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <path
// //                       d="M16 48C16 40 22 36 32 36C42 36 48 40 48 48"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                   </svg>
// //                   <span>Omkar Consultancy Team</span>
// //                 </div>
// //               </div>
// //               <h2 className="featured-title">
// //                 10 Key Benefits of ISO 9001:2015 Certification
// //               </h2>
// //               <p className="featured-description">
// //                 Discover how ISO 9001:2015 certification can transform your
// //                 organization and boost customer satisfaction.
// //               </p>
// //               <button className="read-link" onClick={() => navigate("/blog/1")}>
// //                 Read Full Article
// //                 <span className="read-arrow">
// //                   <svg
// //                     width="18"
// //                     height="18"
// //                     viewBox="0 0 24 24"
// //                     fill="none"
// //                     stroke="#0B82AD"
// //                     strokeWidth="2"
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                   >
// //                     <path d="M5 12h14"></path>
// //                     <path d="M13 5l7 7-7 7"></path>
// //                   </svg>
// //                 </span>
// //               </button>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="featured-card">
// //           <div className="featured-image">
// //             <span className="badge">ISO</span>
// //             <video className="blog-video" controls autoPlay muted loop>
// //               <source src={Blog1} type="video/mp4" />
// //               Your browser does not support the video tag.
// //             </video>
// //           </div>
// //           <div className="featured-content">
// //             <div className="card1">
// //               <div className="meta">
// //                 <div className="meta-item">
// //                   <svg width="20" height="20" viewBox="0 0 64 64" fill="none">
// //                     <rect
// //                       x="12"
// //                       y="18"
// //                       width="40"
// //                       height="34"
// //                       rx="6"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <line
// //                       x1="12"
// //                       y1="26"
// //                       x2="52"
// //                       y2="26"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <line
// //                       x1="22"
// //                       y1="12"
// //                       x2="22"
// //                       y2="22"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                     <line
// //                       x1="42"
// //                       y1="12"
// //                       x2="42"
// //                       y2="22"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                   </svg>
// //                   <span>January 25, 2026</span>
// //                 </div>
// //                 <div className="meta-item">
// //                   <svg width="20" height="20" viewBox="0 0 64 64" fill="none">
// //                     <circle
// //                       cx="32"
// //                       cy="22"
// //                       r="8"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                     />
// //                     <path
// //                       d="M16 48C16 40 22 36 32 36C42 36 48 40 48 48"
// //                       stroke="#0E7490"
// //                       strokeWidth="3"
// //                       strokeLinecap="round"
// //                     />
// //                   </svg>
// //                   <span>Omkar Consultancy Team</span>
// //                 </div>
// //               </div>
// //               <h2 className="featured-title">
// //                 10 Key Benefits of ISO 9001:2015 Certification
// //               </h2>
// //               <p className="featured-description">
// //                 Discover how ISO 9001:2015 certification can transform your
// //                 organization and boost customer satisfaction.
// //               </p>
// //               <button className="read-link" onClick={() => navigate("/blog/1")}>
// //                 Read Full Article
// //                 <span className="read-arrow">
// //                   <svg
// //                     width="18"
// //                     height="18"
// //                     viewBox="0 0 24 24"
// //                     fill="none"
// //                     stroke="#0B82AD"
// //                     strokeWidth="2"
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                   >
// //                     <path d="M5 12h14"></path>
// //                     <path d="M13 5l7 7-7 7"></path>
// //                   </svg>
// //                 </span>
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //       <section>
// //         <BlogCard />
// //       </section>
// //       <Footer />
// //     </div>
// //   );
// // };

// // export default Blog;
// import React, { useEffect, useState } from "react";
// import "./Blog.css";
// import BLogImg from "../../assets/Images/Blog_hero.png";
// import BlogCard from "./BlogCard";
// import Footer from "../../components/Footer";
// import { useNavigate } from "react-router-dom";

// const Blog = () => {
//   const navigate = useNavigate();
//   const [featured, setFeatured] = useState(null);

//   useEffect(() => {
//     fetch("https://www.sirsonite.in/sirsonite-d/omkaradmin/api/blogs")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success && data.featured.length > 0) {
//           setFeatured(data.featured[0]);
//         }
//       })
//       .catch((err) => console.error(err));
//   }, []);

//   return (
//     <div>
//       {/* HERO */}
//       <section className="blog-featured">
//         <div className="blog-image">
//           <img src={BLogImg} alt="Blog cover" />
//           <div className="overlay"></div>
//         </div>

//         <div className="blog-content">
//           <h1 className="blog-title">ISO Knowledge Hub</h1>
//           <p className="blog-description">
//             Expert insights, best practices, and latest updates on ISO certification
//           </p>
//         </div>
//       </section>

//       {/* FEATURED */}
//       <section className="featured-section">
//         <div className="section-label-wrapper">
//           <div className="section-label">
//             <span className="dot"></span>
//             <span className="label-text">Featured Article</span>
//           </div>
//         </div>

//         {featured && (
//           <div className="featured-card">
//             <div className="featured-image">
//               <span className="badge">ISO</span>
//               <img src={featured.image} alt={featured.heading} />
//             </div>

//             <div className="featured-content">
//               <div className="card1">
//                 <div className="meta">
//                   <span>{featured.date}</span>
//                   <span>Omkar Consultancy Team</span>
//                 </div>

//                 <h2 className="featured-title">{featured.heading}</h2>
//                 <p className="featured-description">{featured.short}</p>

//                 <button
//                   className="read-link"
//                   onClick={() => navigate(`/blog/${featured.slug}`)}
//                 >
//                   Read Full Article →
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </section>

//       {/* BLOG LIST */}
//       <BlogCard />

//       <Footer />
//     </div>
//   );
// };

// export default Blog;

import React, { useEffect, useState } from "react";
import "./Blog.css";
import BLogImg from "../../assets/Images/Blog_hero.png";
import BlogCard from "./BlogCard";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const navigate = useNavigate();
  const [featured, setFeatured] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  useEffect(() => {
    fetch(`${BASE_URL}blogs`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.featured.length > 0) {
          setFeatured(data.featured[0]);
        }
      })
      .catch(console.error);
  }, []);

  return (
    <div>
      <section className="blog-featured">
        <div className="blog-image">
          <img src={BLogImg} alt="Blog cover" />
          <div className="overlay"></div>
        </div>

        <div className="blog-content">
          <h2 class="text-white">ISO Knowledge Hub</h2>
          <p className="blog-description">
            Expert insights, best practices, and latest updates
          </p>
        </div>
      </section>

      <section className="featured-section">
        <div className="section-label-wrapper">
          <div className="section-label">
            <span className="dot"></span>
            <span className="label-text">Featured Article</span>
          </div>
        </div>

        {featured && (
          <div className="featured-card">
            <div className="featured-image">
              <span className="badge">ISO</span>
              <img src={featured.image} alt={featured.heading} />
            </div>

            <div className="featured-content">
              <div className="card1">
                <div className="meta">
                  <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_37_1839)">
                      <path d="M5.33301 1.33334V4.00001" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M10.667 1.33334V4.00001" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12.6667 2.66666H3.33333C2.59695 2.66666 2 3.26361 2 3.99999V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V3.99999C14 3.26361 13.403 2.66666 12.6667 2.66666Z" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M2 6.66666H14" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_37_1839">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg> {featured.date}</span>
                  <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12.6663 14V12.6667C12.6663 11.9594 12.3854 11.2811 11.8853 10.781C11.3852 10.281 10.7069 10 9.99967 10H5.99967C5.29243 10 4.61415 10.281 4.11406 10.781C3.61396 11.2811 3.33301 11.9594 3.33301 12.6667V14" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.99967 7.33333C9.47243 7.33333 10.6663 6.13943 10.6663 4.66667C10.6663 3.19391 9.47243 2 7.99967 2C6.52692 2 5.33301 3.19391 5.33301 4.66667C5.33301 6.13943 6.52692 7.33333 7.99967 7.33333Z" stroke="#0B82AD" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                  </svg> {featured.author}</span>
                </div>

                <h4 class="text-black">{featured.heading}</h4>

                <p className="featured-description"
                dangerouslySetInnerHTML={{ __html: featured.short }}
                ></p>

                <button
                  className="read-link"
                  onClick={() => navigate(`/blog/${featured.slug}`)}
                >
                  Read Full Article →
                </button>
              </div>
            </div>
          </div>
        )}
      </section>

      <BlogCard />
      <Footer />
    </div>
  );
};

export default Blog;